import React from 'react';

function Pipes({ pipes }) {
    return (
      <>
        {pipes.map((pipe, index) => (
          <React.Fragment key={index}>
            {/* Top pipe */}
            <div
              style={{
                position: 'absolute',
                left: `${pipe.x}px`,
                top: 0,
                width: '50px',
                height: `${pipe.topHeight}px`,
                backgroundColor: '#228B22',
                boxShadow: 'inset 2px 0px 5px rgba(0,0,0,0.3)',
                zIndex: 3,
                overflow: 'visible'
              }}
            >
              {/* Top pipe lip */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '-10px',
                  left: '-7px',
                  width: 'calc(100% + 14px)',
                  height: '10px',
                  backgroundColor: '#2E8B57',
                  borderRadius: '6px 6px 0 0',
                  boxShadow: 'inset 0px 3px 3px rgba(0,0,0,0.4)',
                  zIndex: 4,
                  //borderLeft: '10px solid #228B22',
                  //borderRight: '10px solid #228B22',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            {/* Bottom pipe */}
            <div
              style={{
                position: 'absolute',
                left: `${pipe.x}px`,
                top: `${pipe.topHeight + pipe.gap}px`,
                width: '50px',
                height: `${window.innerHeight - (pipe.topHeight + pipe.gap)}px`,
                backgroundColor: '#228B22',
                boxShadow: 'inset 2px 2px 5px rgba(0,0,0,0.3)',
                zIndex: 3,
                overflow: 'visible'
              }}
            >
              {/* Bottom pipe lip */}
              <div
                style={{
                  position: 'absolute',
                  top: '-10px',
                  left: '-7px',
                  width: 'calc(100% + 14px)',
                  height: '10px',
                  backgroundColor: '#2E8B57',
                  borderRadius: '0 0 6px 6px',
                  boxShadow: 'inset 0px 3px 3px rgba(0,0,0,0.4)',
                  zIndex: 4,
                  //borderLeft: '10px solid #228B22',
                  //borderRight: '10px solid #228B22',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          </React.Fragment>
        ))}
      </>
    );
  }

export default React.memo(Pipes);